const firebaseConfig = {
    apiKey: "AIzaSyD9PhhgtWgJmHmJW1s9RR0Oq1zlBL7AKAg",
  authDomain: "watch-store2.firebaseapp.com",
  projectId: "watch-store2",
  storageBucket: "watch-store2.appspot.com",
  messagingSenderId: "367130441625",
  appId: "1:367130441625:web:eb5ac21d040408d2fd4508"
    };
  
    export default firebaseConfig;